module.exports = __webpack_public_path__ + "static/200317_practical_tips.427e4a9e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/teaching_slides/200317_practical_tips.pdf
// module id = 344
// module chunks = 22885490386278